import { render, staticRenderFns } from "./RecipientsInput.vue?vue&type=template&id=34b6e31e&"
import script from "./RecipientsInput.vue?vue&type=script&lang=js&"
export * from "./RecipientsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports